export default {
    page_title: "Kevi | Campos do cliente",
    title: "Campos do cliente",
    add_group_button: "Adicionar Grupo",
    add_field_button: "Adicionar Campo",
    empty_group_message: "Arraste campos para este grupo.",

    field_form: {
        title: "Criando campo",
        name_label: "Nome",
        type_label: "Tipo",
        back_button: "Voltar",
        save_button: "Salvar",
    },

    group_form_modal: {
        title_create: "Criar Novo Grupo",
        title_edit: "Editar Grupo",
        name_label: "Nome do Grupo",
        name_placeholder: "Ex: Dados Pessoais",
    },

    confirm_delete_group: {
        title: "Gostaria de excluir o grupo",
        body_has_fields:
            "Este grupo contém {0} campo(s). Mova os campos para outro grupo antes de excluir.",
        body_no_fields:
            'Esta ação é irreversível. Os campos dentro dele não serão excluídos, mas movidos para o grupo "Geral".',
        attention: "Atenção:",
        delete_button: "Excluir",
    },

    confirm_delete_field: {
        title: "Gostaria de excluir",
        body_no_relations:
            "Esta ação é irreversível, tem certeza que deseja continuar?",
        body_linked: "Este campo está vinculado",
        linked_automations: "às seguintes automações:",
        linked_segments: "aos seguintes segmentos:",
        warning_linked:
            "É recomendado ajustar antes de remover, continuar agora pode gerar resultados inesperados.",
    },

    confirm_edit_field: {
        title: "Gostaria de editar o nome para",
        body: "Certifique-se de que o novo nome está correto antes de confirmar.",
    },

    tooltips: {
        edit_group: "Editar grupo",
        delete_group: "Excluir grupo",
        edit_field: "Editar campo",
        delete_field: "Excluir campo",
        move_field: "Mover Campo",
    },

    aria: {
        edit_group: "Editar grupo",
        delete_group: "Excluir grupo",
        confirm_edit: "Confirmar edição",
        edit_field: "Editar campo",
        delete_field: "Excluir campo",
        field_name: "Nome",
    },

    notifications: {
        field_added: "Campo adicionado",
        field_deleted: "Campo personalizado excluído",
        field_edited: "Campo personalizado editado",
        group_created: "Grupo criado",
        group_updated: "Grupo atualizado",
        group_deleted: "Grupo excluído",
        group_name_required: "O nome do grupo é obrigatório.",
        group_has_fields_error: "Não é possível excluir um grupo com campos.",
        group_create_error: "Falha ao criar grupo.",
        group_update_error: "Falha ao atualizar grupo.",
        group_delete_error: "Falha ao excluir grupo.",
        order_saved: "Ordem salva com sucesso!",
        order_save_error: "Falha ao salvar a nova ordem.",
    },
};
